import { createClient } from '@supabase/supabase-js';

// Get environment variables
let supabaseUrl: string;
let supabaseAnonKey: string;

// Try to get values from window.env first (for production)
if (typeof window !== 'undefined' && window.env) {
  supabaseUrl = window.env.VITE_SUPABASE_URL;
  supabaseAnonKey = window.env.VITE_SUPABASE_ANON_KEY;
} else {
  // Fallback to import.meta.env (for development)
  supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
  supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
}

// Validate environment variables
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase environment variables');
  throw new Error('Supabase URL and Anon Key are required');
}

// Initialize Supabase client
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: false,
    storage: window.localStorage
  }
});